<template lang="html">
    <div id="accountContent" ref="accountContent" class="d-flex justify-content-center">
        <loader :active="loading"></loader>
        <modal-o-k :active="false" :mess="mess" :title="successTitle" :showIncrement="modalSuccess" :lang="lang"></modal-o-k>
        <modal-err :active="false" :mess="mess" :title="errorTitle" :showIncrement="modalError" :lang="lang"></modal-err>
        <modal-unhappy :active="false" :showIncrement="modalUnhapp" :lang="lang"></modal-unhappy>
        <div class="accountInner w-100 h-100 d-flex flex-wrap justify-content-center align-items-start align-content-start fitWidth overflow-hidden position-relative" v-if="filled">
            

            <template v-if="view == 'data'">
                <div class="w-100 d-flex justify-content-center text-start titled fw-bold font-4 mt-5">
                    <div class="col-xxl-7 col-lg-10 col-11 d-flex justify-content-start">
                        <span class="col-12 col-md-9 text-start" v-html="phrases.f5[lang]"></span>
                    </div>
                </div>
                <div class="w-100 d-flex justify-content-center text-start pointTitle font-9 mt-2">
                    <div class="col-xxl-7 col-lg-10 col-11 d-flex justify-content-start">
                        <span class="col-12 col-md-9 text-start ps-md-3">{{phrases.f10[lang]}}</span>
                    </div>
                </div>
                <div class="w-100 d-flex justify-content-center text-start my-5">
                    <div class="col-xxl-7 col-lg-10 col-11">
                        <div class="col-12 text-start ms-md-3 separator"></div>
                    </div>
                </div>
                <div class="w-100 d-flex flex-wrap justify-content-center">
                    <div class="col-xxl-7 col-lg-10 col-11 d-flex flex-wrap justify-content-center">
                        <div class="col-12 col-md-6 ps-md-5 ps-2 pe-2 pe-md-3">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f11[lang]}}*</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3">
                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  id="nameAccount" name="nameAccount" @input="unMarkRed('nameAccount')" @change="unMarkRed('nameAccount')" v-model="form.name" :placeholder="phrases.f11[lang]" class="inputLogin w-100 px-3 font-7" maxlength="50" type="text">
                            </div>
                        </div>
                        <div class="col-12 col-md-6 pe-md-5 pe-2 ps-2 ps-md-3 mt-4 mt-md-0">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f12[lang]}}*</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3">
                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  id="lastNameAccount" name="lastNameAccount"  @input="unMarkRed('lastNameAccount')"  @change="unMarkRed('lastNameAccount')" v-model="form.lastName" :placeholder="phrases.f12[lang]" class="inputLogin w-100 px-3 font-7" maxlength="50" type="text">
                            </div>
                        </div>
                        <div class="col-12 col-md-6 ps-md-5 ps-2 pe-2 pe-md-3 mt-4">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f14[lang]}}*</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3">
                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  id="emailAccount" name="emailAccount"  @input="unMarkRed('emailAccount')" @change="unMarkRed('emailAccount')"  v-model="form.email" :placeholder="phrases.f15[lang]" class="inputLogin pushable w-100 px-3 font-7" maxlength="100" type="text" tabindex="-1">
                            </div>
                        </div>
                        <div class="col-12 col-md-6 pe-md-5 pe-2 ps-2 ps-md-3 mt-4">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f38[lang]}}*</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3">
                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  id="numberAccount" name="numberAccount" @input="unMarkRed('numberAccount')"  @change="unMarkRed('numberAccount')" v-model="form.number" :placeholder="phrases.f3[lang]" class="inputLogin pe-none opacity-50 w-100 px-3 font-7" maxlength="10" type="text">
                            </div>
                        </div>
                        <div class="col-12 col-md-6 ps-md-5 ps-2 pe-2 pe-md-3 mt-5">
                            <div class="col-12 text-start d-flex justify-content-start ps-3 mt-5 mt-md-0">
                                <button class="accountButton pushable col-12 px-4 py-3 font-9" @click="closeSess()">{{phrases.f1[lang]}}</button>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 pe-md-5 pe-2 ps-2 ps-md-3 mt-md-5 mt-3">
                            <div class="col-12 text-start d-flex justify-content-start justify-content-md-end ps-3">
                                <button class="accountButton pushable active col-12 col-7 font-9 px-4 py-3" @click="saveAccountInfo()"> <template v-if="accountDataPending">{{phrases.f4[lang]}}</template><template v-else>{{phrases.f39[lang]}}</template></button >
                            </div>
                        </div>
                        <div class="col-12 ps-md-5 ps-2 pe-2 pe-md-5 mt-5">
                            <div class="col-12 subtitled font-7  text-start mb-3">{{phrases.f2[lang]}}</div>
                            <div class="col-12 text-start d-flex flex-wrap justify-content-end ps-3">
                                <div class="addressCard w-100 d-flex mb-4 position-relative"
                                    :class="{ 'addressCard--default': user.data.deliveryDir == address.title }"
                                    @click="editAddress(adix)"
                                    v-for="(address, adix) in addresses">
                                    <template v-if="address.colony.value != '' && address.street.value != ''">
                                        <div class="addressCard__icon" :aria-hidden="true">
                                            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path :d="addressIconPaths[getAddressIcon(address.dwelling && address.dwelling.value)]"></path>
                                            </svg>
                                        </div>
                                        <div class="addressCard__content">
                                            <div class="addressCard__head">
                                                <span class="addressCard__title">{{ (address.dwelling && address.dwelling.value) || address.colony.value }}</span>
                                                <span class="addressCard__badge" v-if="user.data.deliveryDir == address.title">{{phrases.f49[lang]}}</span>
                                            </div>
                                            <div class="addressCard__line">
                                                {{ address.street.value }}{{ address.extNumber.value ? ' #'+address.extNumber.value : '' }}{{ address.intNumber.value ? ' int. '+address.intNumber.value : '' }}
                                            </div>
                                            <div class="addressCard__line addressCard__line--muted">
                                                {{ address.colony.value }}{{ address.crossings.value ? ' · '+address.crossings.value : '' }}
                                            </div>
                                            <div class="addressCard__comment" v-if="address.comment.value">
                                                {{ address.comment.value }}
                                            </div>
                                        </div>
                                        <div class="addressCard__actions" @click.stop>
                                            <button type="button" class="addressCard__btn" v-if="user.data.deliveryDir != address.title" @click="selectAddress($event, address.title)" :title="phrases.f43[lang]" :aria-label="phrases.f43[lang]">
                                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>
                                            </button>
                                            <button type="button" class="addressCard__btn" @click="editAddress(adix)" :title="phrases.f26[lang]" :aria-label="phrases.f26[lang]">
                                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 000-1.41l-2.34-2.34a1 1 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></svg>
                                            </button>
                                            <button type="button" class="addressCard__btn addressCard__btn--danger" v-if="user.data.deliveryDir != address.title && addresses.length > 1" @click="removeAddress($event, address.title)" :title="phrases.f46[lang]" :aria-label="phrases.f46[lang]">
                                                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path></svg>
                                            </button>
                                        </div>
                                    </template>

                                </div>
                                <template v-if="addresses.length == 0">
                                    <div class="textareaSimulator w-100 d-flex flex-wrap font-9 position-relative" @click="addNewAddress()">
                                        {{phrases.f27[lang]}}
                                        <div class="editAccess font-8">{{phrases.f28[lang]}}</div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="col-12 col-md-6 pe-0 mt-md-5 mt-3">
                                        <div class="col-12 text-start d-flex justify-content-end ps-0 ps-md-3">
                                            <button class="accountButton pushable active col-12 col-7 font-9 px-0 py-3" @click="addNewAddress()">{{phrases.f40[lang]}}</button >
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-else-if="view == 'dir'">
                <div class="w-100 d-flex justify-content-center text-start titled font-4 background-color: var(--primary);
                border: 2px solid var(--primary);
                color:var(--text2);
                filter: contrast(0.9); mt-5">
                    <div class="col-xxl-7 col-lg-10 col-11 d-flex justify-content-start">
                        <span class="col-12 col-md-9 text-start fw-bold" v-html="phrases.f7[lang]"></span>
                    </div>
                </div>
                <div class="w-100 d-flex justify-content-center text-start pointTitle font-9 mt-2">
                    <div class="col-xxl-7 col-lg-10 col-11 d-flex justify-content-start">
                        <span class="col-12 col-md-9 text-start ps-md-3">{{phrases.f10[lang]}}</span>
                    </div>
                </div>
                <div class="w-100 d-flex justify-content-center text-start my-5">
                    <div class="col-xxl-7 col-lg-10 col-11">
                        <div class="col-12 text-start ms-md-3 separator"></div>
                    </div>
                </div>
                <div class="w-100 d-flex flex-wrap justify-content-center mb-md-5">
                    <div class="col-xxl-7 col-lg-10 col-11 d-flex flex-wrap justify-content-center">

                        <div class="col-12 px-md-5 px-2 mt-4">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f41[lang]}}*</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3 position-relative">
                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" id="dwellingAccount" name="dwellingAccount" @input="unMarkRed('dwellingAccount')" @change="unMarkRed('dwellingAccount')" v-model="addresses[selectedIndexAddress].dwelling.value" :placeholder="phrases.f42[lang]" class="inputAddress w-100 ps-3 font-7" maxlength="40" type="text">
                                <div class="superponIcon d-flex align-items-center align-content-center justify-content-center pe-3">
                                    <svg class="errorIcon" viewBox="0 0 180 180" width="100" height="100" v-if="addresses[selectedIndexAddress].dwelling.error === true">
                                        <circle cx="90" cy="90" r="90" stroke-width="0" />
                                        <line x1="45" y1="45" x2="135" y2="135" stroke-width="12" />
                                        <line x1="45" y1="135" x2="135" y2="45" stroke-width="12" />
                                    </svg>
                                    <svg class="checkIcon" viewBox="0 0 180 180" v-else-if="addresses[selectedIndexAddress].dwelling.error === false">
                                        <circle class="circled" cx="90" cy="90" r="90" stroke-width="3">
                                        </circle>
                                        <path d="M50 90 L80 120 L130 70" stroke-width="12" fill="transparent">
                                        </path>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 px-md-5 px-2 mt-4">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f16[lang]}}*</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3 position-relative">
                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" id="streetAccount" name="streetAccount" @input="unMarkRed('streetAccount')" @change="unMarkRed('streetAccount')" v-model="addresses[selectedIndexAddress].street.value" :placeholder="phrases.f17[lang]" class="inputAddress w-100 ps-3 font-7" maxlength="100" type="text">
                                <div class="superponIcon d-flex align-items-center align-content-center justify-content-center pe-3">
                                    <svg class="errorIcon" viewBox="0 0 180 180" width="100" height="100" v-if="addresses[selectedIndexAddress].street.error === true">
                                        <circle cx="90" cy="90" r="90" stroke-width="0" />
                                        <line x1="45" y1="45" x2="135" y2="135" stroke-width="12" />
                                        <line x1="45" y1="135" x2="135" y2="45" stroke-width="12" />
                                    </svg>
                                    <svg class="checkIcon" viewBox="0 0 180 180" v-else-if="addresses[selectedIndexAddress].street.error === false">
                                        <circle class="circled" cx="90" cy="90" r="90" stroke-width="3">
                                        </circle>
                                        <path d="M50 90 L80 120 L130 70" stroke-width="12" fill="transparent">
                                        </path>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 px-md-5 px-2 mt-4">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f30[lang]}}*</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3 position-relative">
                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  id="extNAccount" name="extNAccount" @input="unMarkRed('extNAccount'); alfanumericsData('addresses', 0, 'extNumber')" @change="unMarkRed('extNAccount')" v-model="addresses[selectedIndexAddress].extNumber.value" placeholder="145" class="inputAddress w-100 px-3 font-7" maxlength="5" type="text">
                                <div class="superponIcon d-flex align-items-center align-content-center justify-content-center pe-3">
                                    <svg class="errorIcon" viewBox="0 0 180 180" width="100" height="100" v-if="addresses[selectedIndexAddress].extNumber.error === true">
                                        <circle cx="90" cy="90" r="90" stroke-width="0" />
                                        <line x1="45" y1="45" x2="135" y2="135" stroke-width="12" />
                                        <line x1="45" y1="135" x2="135" y2="45" stroke-width="12" />
                                    </svg>
                                    <svg class="checkIcon" viewBox="0 0 180 180" v-else-if="addresses[selectedIndexAddress].extNumber.error === false">
                                        <circle class="circled" cx="90" cy="90" r="90" stroke-width="3">
                                        </circle>
                                        <path d="M50 90 L80 120 L130 70" stroke-width="12" fill="transparent">
                                        </path>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 px-md-5 px-2 mt-4">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f31[lang]}}</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3 position-relative">
                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  id="intNAccount" name="intNAccount" @input="unMarkRed('intNAccount'); alfanumericsData('addresses', 0, 'intNumber')" @change="unMarkRed('intNAccount')" v-model="addresses[selectedIndexAddress].intNumber.value" placeholder="145" class="inputAddress w-100 px-3 font-7" maxlength="5" type="text">
                                <div class="superponIcon d-flex align-items-center align-content-center justify-content-center pe-3">
                                    <svg class="errorIcon" viewBox="0 0 180 180" width="100" height="100" v-if="addresses[selectedIndexAddress].intNumber.error === true">
                                        <circle cx="90" cy="90" r="90" stroke-width="0" />
                                        <line x1="45" y1="45" x2="135" y2="135" stroke-width="12" />
                                        <line x1="45" y1="135" x2="135" y2="45" stroke-width="12" />
                                    </svg>
                                    <svg class="checkIcon" viewBox="0 0 180 180" v-else-if="addresses[selectedIndexAddress].intNumber.error === false">
                                        <circle class="circled" cx="90" cy="90" r="90" stroke-width="3">
                                        </circle>
                                        <path d="M50 90 L80 120 L130 70" stroke-width="12" fill="transparent">
                                        </path>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 px-md-5 px-2 mt-4">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f32[lang]}}</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3 position-relative">
                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  id="crossingsAccount" name="crossingsAccount" @input="unMarkRed('crossingsAccount')" @change="unMarkRed('crossingsAccount')" v-model="addresses[selectedIndexAddress].crossings.value" :placeholder="phrases.f33[lang]" class="inputAddress w-100 px-3 font-7" maxlength="100" type="text">
                                <div class="superponIcon d-flex align-items-center align-content-center justify-content-center pe-3">
                                    <svg class="errorIcon" viewBox="0 0 180 180" width="100" height="100" v-if="addresses[selectedIndexAddress].crossings.error === true">
                                        <circle cx="90" cy="90" r="90" stroke-width="0" />
                                        <line x1="45" y1="45" x2="135" y2="135" stroke-width="12" />
                                        <line x1="45" y1="135" x2="135" y2="45" stroke-width="12" />
                                    </svg>
                                    <svg class="checkIcon" viewBox="0 0 180 180" v-else-if="addresses[selectedIndexAddress].crossings.error === false">
                                        <circle class="circled" cx="90" cy="90" r="90" stroke-width="3">
                                        </circle>
                                        <path d="M50 90 L80 120 L130 70" stroke-width="12" fill="transparent">
                                        </path>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 px-md-5 px-2 mt-4">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f9[lang]}}*</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3 position-relative">
                                <div class="filler font-7 ms-3"  v-show="choosingCity" ref="filler3">
                                    <div v-for="city in cities" class="py-2 colony ps-4" @click="setCity(city)">
                                        {{city.friendlyName}}
                                    </div>
                                </div>
                                <div 
                                    ref="filler4"
                                    id="cityAccount"
                                    name="cityAccount"
                                    @click="checkCities()" 
                                    @change="unMarkRed('cityAccount')" 
                                    v-text="referedCity" 
                                    class="inputAddress d-flex align-items-center align-content-center w-100 ps-3 font-7">
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 px-md-5 px-2 mt-4">

                            <div class="col-12 subtitled font-7 text-start mb-3 d-flex align-items-center align-content-center">
                                {{phrases.f18[lang]}}* 
                            </div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3 position-relative">
                                <div class="filler font-7 ms-3" v-show="searchingColonies && colonies.length > 0" ref="filler">
                                    <div v-for="colony in colonies" class="py-2 colony ps-4" @click="setColony(colony)">
                                        {{colony.d_asenta}}&nbsp;-&nbsp;{{colony.d_codigo}}
                                    </div>
                                </div>
                                <input 
                                    ref="filler2"
                                    autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  id="colonyAccount" name="colonyAccount"
                                    @click="getFillColonies()" 
                                    @input="checkColonies($event)" 
                                    @blur="checkColonyValid()"
                                    @change="unMarkRed('colonyAccount')" 
                                    v-model="referedColony" 
                                    :placeholder="phrases.f19[lang]" 
                                    class="inputAddress w-100 ps-3 font-7" 
                                    maxlength="60" 
                                    type="text">
                                    <div class="superponIcon d-flex align-items-center align-content-center justify-content-center pe-3">
                                        <svg class="errorIcon" viewBox="0 0 180 180" width="100" height="100" v-if="addresses[selectedIndexAddress].colony.error === true">
                                            <circle cx="90" cy="90" r="90" stroke-width="0" />
                                            <line x1="45" y1="45" x2="135" y2="135" stroke-width="12" />
                                            <line x1="45" y1="135" x2="135" y2="45" stroke-width="12" />
                                        </svg>
                                        <svg class="checkIcon" viewBox="0 0 180 180" v-else-if="addresses[selectedIndexAddress].colony.error === false">
                                            <circle class="circled" cx="90" cy="90" r="90" stroke-width="3">
                                            </circle>
                                            <path d="M50 90 L80 120 L130 70" stroke-width="12" fill="transparent">
                                            </path>
                                        </svg>
                                    </div>
                            </div>
                            
                        </div>  
                        <div class="col-12 px-md-5 px-2 mt-4">
                            <div class="col-12 subtitled font-7 text-start mb-3">{{phrases.f20[lang]}}*</div>
                            <div class="col-12 text-start d-flex justify-content-end ps-3 position-relative">
                                <input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  id="commentdirAccount" name="commentdirAccount" @input="unMarkRed('commentdirAccount')" @blur="checkInputValue('addresses', 0, 'comment', 'regComment', [0, 2])" @change="unMarkRed('commentdirAccount')" v-model="addresses[selectedIndexAddress].comment.value" :placeholder="phrases.f29[lang]" class="inputAddress w-100 px-3 font-7" maxlength="100" type="text">
                                <div class="superponIcon d-flex align-items-center align-content-center justify-content-center pe-3">
                                    <svg class="errorIcon" viewBox="0 0 180 180" width="100" height="100" v-if="addresses[selectedIndexAddress].comment.error === true">
                                        <circle cx="90" cy="90" r="90" stroke-width="0" />
                                        <line x1="45" y1="45" x2="135" y2="135" stroke-width="12" />
                                        <line x1="45" y1="135" x2="135" y2="45" stroke-width="12" />
                                    </svg>
                                    <svg class="checkIcon" viewBox="0 0 180 180" v-else-if="addresses[selectedIndexAddress].comment.error === false">
                                        <circle class="circled" cx="90" cy="90" r="90" stroke-width="3">
                                        </circle>
                                        <path d="M50 90 L80 120 L130 70" stroke-width="12" fill="transparent">
                                        </path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 px-md-5 px-2 mt-5">
                            <div class="col-12 text-start d-flex justify-content-start justify-content-md-end ps-3">
                                <button class="accountButton pushable col-12 col-7 font-9 px-4 py-3" @click="returnToData()">{{phrases.f8[lang]}}</button >
                            </div>
                        </div> 
                        <div class="col-12 col-md-6 px-md-5 px-2 mt-5 mb-md-5">
                            <div class="col-12 text-start d-flex justify-content-start justify-content-md-end ps-3">
                                <button class="accountButton pushable active col-12 col-7 font-9 px-4 py-3" @click="updateAddressInfo()"><template v-if="addressDataPending">{{phrases.f6[lang]}}</template><template v-else>{{phrases.f39[lang]}}</template></button >
                            </div>
                        </div>

                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import loader from "@/components/common/loader.vue";
import modalOK from "@/components/common/successModal.vue";
import modalErr from "@/components/common/errorModal.vue";
import modalUnhappy from "@/components/common/unhappyModal.vue";

export default {
    name:"accountWizard",
    emits:['event'],
    components:{
        loader,
        modalOK,
        modalErr,
        modalUnhappy
    },
    props:{
        lang:{
            default:"es",
            type: String
        },
        user:{
            type:Object,
            default:{}
        },
        socket:{
            default:{},
            type: Object
        },
        con:{
            default:{},
            type: Object
        },
        transfer:{
            type:Object,
            default:{}
        },
        cityMenu:{
            default:{},
            type: Object
        },
        cities:{
            default:[],
            type: Array
        }
    },
    watch:{
        user(){
            this.accountNotEmpty();
        }
    },
    mounted(){
        this.accountNotEmpty();
        document.addEventListener('click', this.handleClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClick);
    },
    methods:{

        getAddressIcon(dwelling){
            const first = (dwelling || '').trim().toLowerCase().split(/\s+/)[0];
            return this.addressIconKeywords[first] || 'pin';
        },

        removeAddress(e, title){
            e.stopPropagation();
            this.loading = true;
            this.con.eraseAddress(
                {
                    "token":this.user.token,
                    "dwellingID":title
                }
            ).then((res)=>{
                this.loading = false;
                if(res.code == 200){
                    this.successTitle = this.phrases.f47[this.lang];
                    this.mess = this.phrases.f48[this.lang];
                    this.modalSuccess += 1;
                    this.$parent.$emit('event', {type:'updateSession', time:0})
                    this.accountDataPending = false;
                }else{
                    this.errorTitle = this.phrases.f24[this.lang];
                    this.mess = res.msj;
                    this.modalError += 1;
                }
            }).catch((err)=>{
                this.loading = false;
                this.errorTitle = this.phrases.f21[this.lang];
                this.mess = this.phrases.f24[this.lang];
                this.modalError += 1;
            })
        },

        selectAddress(e, title){
            e.stopPropagation();
            this.loading = true;
            this.con.setDeliveryAddress(
                {
                    "token":this.user.token,
                    "data":{
                        "destination":title
                    }
                }
            ).then((res)=>{
                this.loading = false;
                if(res.code == 200){
                    this.successTitle = this.phrases.f44[this.lang];
                    this.mess = this.phrases.f45[this.lang] + title;
                    this.modalSuccess += 1;
                    this.$parent.$emit('event', {type:'updateSession', time:0})
                    this.accountDataPending = false;
                }else{
                    this.errorTitle = this.phrases.f24[this.lang];
                    this.mess = res.msj;
                    this.modalError += 1;
                }
            }).catch((err)=>{
                this.loading = false;
                this.errorTitle = this.phrases.f21[this.lang];
                this.mess = this.phrases.f24[this.lang];
                this.modalError += 1;
            })
        },

        addNewAddress(){

            let directionObject = {};

            directionObject.title = null;
            directionObject.dwelling = {
                value:"",
                error:"",
            },
            directionObject.colony = {
                value:"",
                error:"",
            },
            directionObject.crossings = {
                value:"",
                error:"",
            },
            directionObject.intNumber = {
                value:"",
                error:"",
            },
            directionObject.extNumber = {
                value:"",
                error:"",
            },
            directionObject.street = {
                value:"",
                error:"",
            },
            directionObject.comment = {
                value:"",
                error:"",
            },
            directionObject.storeNumber = "";
            directionObject.street.value = '';
            directionObject.extNumber.value = '';
            directionObject.intNumber.value = '';
            directionObject.crossings.value = '';
            directionObject.colony.value = '';
            directionObject.typeColony = '';
            directionObject.comment.value = '';
            directionObject.zip = '';
            directionObject.state = '';
            directionObject.city = this.cityMenu.friendlyName || '';
            [directionObject.stateCode, directionObject.cityCode] = this.getLocationCodes(this.cityMenu.friendlyName);
            
            this.addresses.push(directionObject);
            this.selectedIndexAddress = this.addresses.length-1;
            this.referedCity = this.cityMenu.friendlyName || '';
            this.referedColony = this.addresses[this.selectedIndexAddress].colony.value || '';
            this.view = 'dir';
            window.scrollTo({
                top: this.$refs.accountContent.offsetTop -180,
                behavior: 'instant'
            });
        },

        checkInputValue(array, index, key, reg='regText', results=[0]){
            if( results.includes(this.verify(this[reg], this[array][index][key].value)) ) {
                this[array][index][key].error = true;
            }else{
                this[array][index][key].error = false;
            }
        },

        alfanumericsData(array, index, key) {
            let value = this[array][index][key].value;
            value = value.replace(/[^a-zA-Z0-9]/g, '');
            this[array][index][key].value = value;
        },
        
        removeAllReds(){
            setTimeout(()=>{
                document.querySelectorAll('.RedFocus').forEach((elm)=>{
                    elm.classList.remove('RedFocus')
                })
            }, 1500)
        },
        getFillColonies(){
            setTimeout(()=>{
                this.searchingColonies = true;
            }, 50)
        },
        handleClick(event) {
            if(this.$refs.filler && this.$refs.filler2 && this.searchingColonies){
                if (!this.$refs.filler.contains(event.target) && !this.$refs.filler2.contains(event.target)) {
                    this.searchingColonies = false;
                }
            }
            if(this.$refs.filler3 && this.$refs.filler4 && this.choosingCity){
                if (!this.$refs.filler3.contains(event.target) && !this.$refs.filler4.contains(event.target)) {
                    this.choosingCity = false;
                }
            }
        },
        returnToData(){
            if(this.$route.query.fromCar){
                this.$router.replace({
                    name: 'order',
                    query: { fromDirection: true },
                });
            }else{
                this.view = 'data';
                this.accountNotEmpty();
                window.scrollTo({
                    top: this.$refs.accountContent.offsetTop -180,
                    behavior: 'instant'
                });
            }
        },
        accountNotEmpty(){
            if(Object.entries(this.user.data).length > 0){

                this.form.name = String(this.user.data.name),
                this.form.lastName = String(this.user.data.lastName),
                this.form.email = String(this.user.data.email),
                this.form.number = String(this.user.data.phone1),

                this.addresses = [];

                let count = 0;

                for(let i in this.user.data.homes){
                    this.addresses.push({});

                    this.addresses[count].title = i;
                    this.addresses[count].dwelling = {
                        value:i,
                        error:"",
                    },
                    this.addresses[count].colony = {
                        value:"",
                        error:"",
                    },
                    this.addresses[count].crossings = {
                        value:"",
                        error:"",
                    },
                    this.addresses[count].intNumber = {
                        value:"",
                        error:"",
                    },
                    this.addresses[count].extNumber = {
                        value:"",
                        error:"",
                    },
                    this.addresses[count].street = {
                        value:"",
                        error:"",
                    },
                    this.addresses[count].comment = {
                        value:"",
                        error:"",
                    },
                    this.addresses[count].storeNumber = "";
                    this.addresses[count].street.value = this.user.data.homes[i].street || '';
                    this.addresses[count].extNumber.value = this.user.data.homes[i].extNumber || '';
                    this.addresses[count].intNumber.value = this.user.data.homes[i].intNumber || '';
                    this.addresses[count].crossings.value = this.user.data.homes[i].crossings || '';
                    this.addresses[count].colony.value = this.user.data.homes[i].colony || '';
                    this.addresses[count].typeColony = this.user.data.homes[i].typeColony || '';
                    this.addresses[count].comment.value = this.user.data.homes[i].refer || '';
                    this.addresses[count].zip = this.user.data.homes[i].zip || '';
                    this.addresses[count].state = this.user.data.homes[i].state || '';
                    this.addresses[count].city = this.user.data.homes[i].city || '';
                    [this.addresses[count].stateCode, this.addresses[count].cityCode] = this.getLocationCodes(this.user.data.homes[i].city);
                    count += 1;
                }

                this.filled = true;
                this.loading = false;

                if(this.$route.query.fromCar){

                    if(this.$route.query.fromCar){
                        if(this.pendingRelogin == false){

                            for(let i in this.addresses){
                                if(this.addresses[i].title == this.$route.query.dirFocus){
                                    this.referedCity = this.addresses[i].city || '';
                                    this.referedColony = this.addresses[i].colony.value || '';
                                    this.selectedIndexAddress = i;
                                    this.view = 'dir';
                                    return true
                                }
                            }

                            this.addNewAddress();
                            
                        }else{
                            this.$router.replace({
                                name: 'order',
                                query: { fromDirection: true },
                            });
                        }
                    }
                    
                }
            }
        },
        getLocationCodes(city=""){
            for(let i in this.cities){
                if(this.cities[i].friendlyName == city){
                    return [this.cities[i].cEstado, this.cities[i].cMnpio]
                }
            }
            return ["", ""]
        },
        formChange(){
            if(Object.entries(this.user.data).length > 0){
                try{
                    if(this.user.data.name != this.form.name || this.user.data.lastName != this.form.lastName || this.user.data.phone1 != this.form.number || this.user.data.email != this.form.email){
                        this.accountDataPending = true;
                        return true
                    }
                }catch(err){}
            }
            this.accountDataPending = false;
            return false
        },
        dirChange(){
            if(Object.entries(this.user.data).length > 0){
                let dir1 = Object.keys(this.user.data.homes)[this.selectedIndexAddress];
                if(dir1 != undefined){
                    if(
                        this.user.data.homes[dir1].street != this.addresses[this.selectedIndexAddress].street.value 
                        || this.user.data.homes[dir1].dwelling != this.addresses[this.selectedIndexAddress].dwelling.value 
                        || this.user.data.homes[dir1].intNumber != this.addresses[this.selectedIndexAddress].intNumber.value 
                        || this.user.data.homes[dir1].extNumber != this.addresses[this.selectedIndexAddress].extNumber.value 
                        || this.user.data.homes[dir1].crossings != this.addresses[this.selectedIndexAddress].crossings.value
                        || this.user.data.homes[dir1].colony != this.addresses[this.selectedIndexAddress].colony.value 
                        || this.user.data.homes[dir1].refer != this.addresses[this.selectedIndexAddress].comment.value){
                            this.addressDataPending = true;
                            return true
                    }else{
                        this.addressDataPending = false;
                        return false
                    }
                }
                this.addressDataPending = false;
                return true
            }
            this.addressDataPending = false;
            return false
        },
        checkCities(){
            this.choosingCity = true; //controlador de menu select
        },
        setCity(city={}){
            this.choosingCity = false;
            this.choosingColony = true;
            this.colonies = [];
            this.referedColony = "";
            this.addresses[this.selectedIndexAddress].colony.value = "";
            this.addresses[this.selectedIndexAddress].colony.error = "";
            this.referedCity = city.friendlyName;
            this.addresses[this.selectedIndexAddress].state = city.state;
            this.addresses[this.selectedIndexAddress].city = city.friendlyName;
            [this.addresses[this.selectedIndexAddress].stateCode, this.addresses[this.selectedIndexAddress].cityCode] = this.getLocationCodes(city.friendlyName);
            
            setTimeout(()=>{
                this.choosingColony = false;
            }, 500)
        },
        checkColonyValid(){
            if(this.addresses[this.selectedIndexAddress].colony.value == ""){
                this.referedColony = "";
            }
        },
        setColony(colony={}){

            this.choosingColony = true;
            this.referedColony = colony.d_asenta;

            if(colony.storeNumber == '' || colony.storeNumber == null || colony.storeNumber == 0){
                this.modalUnhapp++;
            }
            this.addresses[this.selectedIndexAddress].colony.error = false;
            this.addresses[this.selectedIndexAddress].storeNumber = colony.storeNumber;
            this.addresses[this.selectedIndexAddress].colony.value = colony.d_asenta;
            this.addresses[this.selectedIndexAddress].typeColony = colony.d_tipo_asenta;
            this.addresses[this.selectedIndexAddress].zip = colony.d_codigo;
            this.addresses[this.selectedIndexAddress].state = colony.d_estado;

            this.searchingColonies = false;
            setTimeout(()=>{
                this.choosingColony = false;
            }, 500)
        },
        checkColonies(e){
            this.addresses[this.selectedIndexAddress].colony.error = "";
            this.addresses[this.selectedIndexAddress].colony.value = "";

            if(!this.choosingColony && this.referedColony.length >= 3){
                let parsedSearch = this.addresses[this.selectedIndexAddress].stateCode+"/"+this.addresses[this.selectedIndexAddress].cityCode+"/"+this.referedColony;
                this.con.getColoniesMatch({token:this.cityMenu.token, url:parsedSearch}).then((res)=>{
                    if(res.code == 200){
                        this.colonies = res.data;
                        this.searchingColonies = true;
                    }
                }).catch((err)=>{})
            }
        },
        saveAccountInfo(){
            this.matchFormAccount().then((validate)=>{
                if(validate && !this.loading){
                    this.loading = true;
                    let request = {
                        token:this.user.token,
                        data:{
                            name:this.form.name,
                            lastName:this.form.lastName,
                            phone:this.user.data.phone1,
                            email:this.form.email
                        }
                    }
                    this.con.updateUser(request).then((res)=>{
                        this.loading = false;
                        if(res.code == 200){
                            this.successTitle = this.phrases.f22[this.lang];
                            this.mess = this.phrases.f23[this.lang];
                            this.modalSuccess += 1;
                            this.$parent.$emit('event', {type:'updateSession', time:0})
                            this.accountDataPending = false;
                        }else{
                            this.errorTitle = this.phrases.f24[this.lang];
                            this.mess = res.msj;
                            this.modalError += 1;
                        }
                    }).catch((err)=>{
                        this.loading = false;
                        this.errorTitle = this.phrases.f21[this.lang];
                        this.mess = this.phrases.f24[this.lang];
                        this.modalError += 1;
                    })
                }
            }).catch((err)=>{this.loading = false;})
        },


        matchFormAccount(){

            return new Promise((resolve)=>{

                let val = true;

                if(!this.formChange()){
                    val = false;
                }

                if(this.verify(this.regNames, this.form.name) == 0 || this.verify(this.regNames, this.form.name) == 2) {
                    this.markRed("nameAccount");
                    val = false;
                }
                if(this.verify(this.regNames, this.form.lastName) == 0 || this.verify(this.regNames, this.form.lastName) == 2) {
                    this.markRed("lastNameAccount");
                    val = false;
                }
                /*if(this.verify(this.regPhone, this.form.number) == 0 || this.verify(this.regPhone, this.form.number) == 2) {
                    this.markRed("numberAccount");
                    val = false;
                }*/
                if(this.verify(this.regEmail, this.form.email) == 0 || this.verify(this.regNames, this.form.email) == 2) {
                    this.markRed("emailAccount");
                    val = false;
                }

                this.removeAllReds();

                if(!val){
                    resolve(val)
                }else{
                    resolve(val)
                }
            }).catch((err)=>{})         
        },
        updateAddressInfo(){
            this.matchFormAddress().then((validate)=>{
                if(validate && !this.addressDataPending){
                    this.view = 'data';
                    return;
                }
                if(validate && !this.loading){
                    this.loading = true;
                    let request = {
                        token:this.user.token,
                        dwellingID: this.addresses[this.selectedIndexAddress].title == null ? '' : encodeURI(this.addresses[this.selectedIndexAddress].title.trim()),
                        data:{
                            "dwelling": this.addresses[this.selectedIndexAddress].dwelling.value,
                            "street": this.addresses[this.selectedIndexAddress].street.value,
                            "extNumber": this.addresses[this.selectedIndexAddress].extNumber.value,
                            "intNumber": this.addresses[this.selectedIndexAddress].intNumber.value,
                            "crossings": this.addresses[this.selectedIndexAddress].crossings.value,
                            "colony": this.addresses[this.selectedIndexAddress].colony.value,
                            "typeColony": this.addresses[this.selectedIndexAddress].typeColony,
                            "city": this.addresses[this.selectedIndexAddress].city,
                            "zip": this.addresses[this.selectedIndexAddress].zip,
                            "state": this.addresses[this.selectedIndexAddress].state,
                            "refer": this.addresses[this.selectedIndexAddress].comment.value
                        }
                    }

                
                    this.con[this.addresses[this.selectedIndexAddress].title == null ? 'saveUserAddress' : 'updateUserAddress'](request).then((res)=>{
                        this.loading = false;
                        if(res.code == 200){
                            this.pendingRelogin = true;
                            this.view = 'data';
                            this.addressDataPending = false;
                            this.$parent.$emit('event', {type:'updateSession', time:0})
                            if(!this.$route.query.fromCar){
                                this.successTitle = this.phrases.f22[this.lang];
                                this.mess = this.phrases.f23[this.lang];
                                this.$nextTick(()=>{ this.modalSuccess += 1; });
                            }
                        }else{
                            this.errorTitle = this.phrases.f21[this.lang];
                            this.mess = this.phrases.f24[this.lang] + ": " + (typeof res.msj == 'object' ? (JSON.stringify(res.msj)) : res.msj )
                            this.modalError += 1;
                        }
                    }).catch((err)=>{
                        console.log(err)
                        this.loading = false;
                        this.errorTitle = this.phrases.f21[this.lang];
                        this.mess = this.phrases.f24[this.lang] ;
                        this.modalError += 1;
                    })
                }
            }).catch((err)=>{this.loading = false;})
        },
        matchFormAddress(){

            return new Promise((resolve, reject)=>{

                let val = true;

                this.dirChange();

                if(this.verify(this.regText2, this.addresses[this.selectedIndexAddress].dwelling.value) == 0 || this.verify(this.regText2, this.addresses[this.selectedIndexAddress].dwelling.value) == 2) {
                    this.addresses[this.selectedIndexAddress].dwelling.error = true;
                    val = false;
                }else{
                    this.addresses[this.selectedIndexAddress].dwelling.error = false;
                }

                if(this.verify(this.regText2, this.addresses[this.selectedIndexAddress].street.value) == 0 || this.verify(this.regText2, this.addresses[this.selectedIndexAddress].street.value) == 2) {
                    this.addresses[this.selectedIndexAddress].street.error = true;
                    val = false;
                }else{
                    this.addresses[this.selectedIndexAddress].street.error = false;
                }
                if(this.verify(this.regAlphanumeric, this.addresses[this.selectedIndexAddress].extNumber.value) == 0 || this.verify(this.regAlphanumeric, this.addresses[this.selectedIndexAddress].extNumber.value) == 2) {
                    this.addresses[this.selectedIndexAddress].extNumber.error = true;
                    val = false;
                }else{
                    this.addresses[this.selectedIndexAddress].extNumber.error = false;
                }
                if(this.verify(this.regAlphanumeric, this.addresses[this.selectedIndexAddress].intNumber.value) == 0) {
                    this.addresses[this.selectedIndexAddress].intNumber.error = true;
                    val = false;
                }else{
                    this.addresses[this.selectedIndexAddress].intNumber.error = false;
                }
                if(this.verify(this.regText, this.addresses[this.selectedIndexAddress].crossings.value) == 0) {
                    this.addresses[this.selectedIndexAddress].crossings.error = true;
                    val = false;
                }else{
                    this.addresses[this.selectedIndexAddress].crossings.error = false;
                }
                if(this.addresses[this.selectedIndexAddress].colony.value == "" || this.addresses[this.selectedIndexAddress].colony.value == null) {
                    this.addresses[this.selectedIndexAddress].colony.error = true;
                    val = false;
                }
                if(this.verify(this.regComment, this.addresses[this.selectedIndexAddress].comment.value) == 0 || this.verify(this.regComment, this.addresses[this.selectedIndexAddress].comment.value) == 2) {
                    this.addresses[this.selectedIndexAddress].comment.error = true;
                    val = false;
                }else{
                    this.addresses[this.selectedIndexAddress].comment.error = false;
                }

                this.removeAllReds();

                if(!val){
                    resolve(val)
                }else{
                    resolve(val)
                }
            }).catch((err)=>{ console.log(err); return false })         
        },
        verify(reg, data){
            data = data.trim();
            if(data == null || data == ""){
                return 2
            }
            if(data.match(reg) == null){
                return 0
            }else{ 
                return 1
            }
        },
        closeSess(){
            this.$parent.$emit('event', {type:'closeSession'});
        },
        editAddress(index){
            this.selectedIndexAddress = index;
            this.referedCity = this.addresses[this.selectedIndexAddress].city || '';
            this.referedColony = this.addresses[this.selectedIndexAddress].colony.value || '';
            this.view = 'dir';
            window.scrollTo({
                top: this.$refs.accountContent.offsetTop -180,
                behavior: 'instant'
            });
        },
        markRed(domId){
            /**
             *
             * marca en rojo un input
             * @param domId: string, id del elemento dom asignarle el estilo
             * @change /
             * @return /
             */

            try{
                document.getElementById(domId).classList.add("RedFocus")
            }
            catch(err){}
        },
        unMarkRed(domId){
            /**
             *
             * desmarca en rojo un input
             * @param domId: string, id del elemento dom retirarle el estilo
             * @change /
             * @return /
             */

            try{
                this.formChange();
                this.dirChange();
                document.getElementById(domId).classList.remove("RedFocus")
            }
            catch(err){}
        },
    },
    data(){
        return{
            view:this.$route.query.direction ? 'dir' : 'data',
            loading:true,
            filled:false,
            pendingRelogin:false,
            addressIconKeywords: {
                casa: 'home', hogar: 'home', home: 'home', depto: 'home', departamento: 'home', depa: 'home',
                oficina: 'office', trabajo: 'office', office: 'office', work: 'office', empresa: 'office',
                escuela: 'school', universidad: 'school', uni: 'school', colegio: 'school', school: 'school',
                gym: 'gym', gimnasio: 'gym',
                restaurante: 'food', restaurant: 'food',
                mamá: 'family', mama: 'family', papá: 'family', papa: 'family',
                hermano: 'family', hermana: 'family', tío: 'family', tio: 'family',
                tía: 'family', tia: 'family', abuela: 'family', abuelo: 'family',
                amigo: 'family', amiga: 'family', novio: 'family', novia: 'family',
            },
            addressIconPaths: {
                home: 'M3 12l9-9 9 9v9h-6v-6H9v6H3z',
                office: 'M4 2h16v20H4zm2 2v2h4V4H6zm6 0v2h4V4h-4zm-6 6v2h4v-2H6zm6 0v2h4v-2h-4zm-3 4h6v6H9z',
                school: 'M12 3L1 9l11 6 9-4.91V17h2V9zM5 13.18V17c0 1.66 3.13 3 7 3s7-1.34 7-3v-3.82L12 17z',
                gym: 'M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z',
                food: 'M8.1 13.34l2.83-2.83L3.91 3.5a4.008 4.008 0 000 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.20-1.09-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z',
                family: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z',
                pin: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z'
            },
            phrases:{
                f1:{
                    es:"Cerrar sesión",
                    en:"Close session"
                },
                f2:{
                    es:"Dirección de entrega",
                    en:"Delivery address"
                },
                f3:{
                    es:"10 dígitos",
                    en:"10 digits"
                },
                f4:{
                    es:"Actualizar información",
                    en:"Update information"
                },
                f5:{
                    es:"Información personal",
                    en:"Personal data"
                },
                f6:{
                    es:"Guardar dirección",
                    en:"Save address"
                },
                f7:{
                    es:"Información de entrega",
                    en:"Delivery info"
                },
                f8:{
                    es:"Regresar",
                    en:"Return"
                },
                f9:{
                    es:"Ciudad",
                    en:"City"
                },
                f10:{
                    es:"Campos obligatorios marcados con *",
                    en:"Personal data"
                },
                f11:{
                    es:"Nombre",
                    en:"Name"
                },
                f12:{
                    es:"Apellido",
                    en:"LastName"
                },
                f13:{
                    es:"Celular",
                    en:"Cellphone"
                },
                f14:{
                    es:"Correo electrónico",
                    en:"Email"
                },
                f15:{
                    es:"correo@email.com",
                    en:"mail@email.com"
                },
                f16:{
                    es:"Calle",
                    en:"Street"
                },
                f17:{
                    es:"Nombre de Calle",
                    en:"Street name"
                },
                f18:{
                    es:"Colonia",
                    en:"Colony"
                },
                f19:{
                    es:"Cólonia o código postal",
                    en:"Colony or zip code"
                },
                f20:{
                    es:"Instrucciones especiales",
                    en:"Special Instructions"
                },
                f21:{
                    es:"Guardado fallido",
                    en:"Save failed"
                },
                f22:{
                    es:"Datos de cuenta actualizados",
                    en:"Updated account details"
                },
                f23:{
                    es:"Su dirección ha sido actualizada correctamente",
                    en:"Your address has been successfully updated"
                },
                f24:{
                    es:"Los datos no ha podido guardarse",
                    en:"Data could not be saved:"
                },
                f25:{
                    es:"Su información ha sido actualizada correctamente",
                    en:"Your address has been successfully updated"
                },
                f26:{
                    es:"Editar",
                    en:"Edit"
                },
                f27:{
                    es:"No tienes una dirección añadida para tus pedidos",
                    en:"You do not have an address added for your orders"
                },
                f28:{
                    es:"Añadir",
                    en:"Add"
                },
                f29:{
                    es:"Portón negro",
                    en:"Black gate"
                },
                f30:{
                    es:"Número Exterior",
                    en:"Ext Number"
                },
                f31:{
                    es:"Número Interior",
                    en:"Int Number"
                },
                f32:{
                    es:"Cruzamientos",
                    en:"Crossings"
                },
                f33:{
                    es:"Por 3 y 5",
                    en:"12th Avenue and 14th Court"
                },
                f34:{
                    es:"Servicio para delivery disponible",
                    en:"Delivery service Available"
                },
                f36:{
                    es:"Servicio para recorger en sucursal disponible",
                    en:"Pickup at store Available"
                },
                f37:{
                    es:"País*",
                    en:"Country*"
                },
                f38:{
                    es:"Teléfono*",
                    en:"Cellphone*"
                },
                f39:{
                    es:"Guardado",
                    en:"Saved"
                },
                f40:{
                    es:"Agregar Dirección",
                    en:"Add Address"
                },
                f41:{
                    es:"Destinatario",
                    en:"Destination"
                },
                f42:{
                    es:"Casa / Oficina",
                    en:"Home / Office"
                },
                f43:{
                    es:"Predeterminar",
                    en:"Predetermine"
                },
                f44:{
                    es:"Dirección Seleccionada",
                    en:"Address Selected"
                },
                f45:{
                    es:"Tu Dirección de envios ahora es: ",
                    en:"Your Delivery Address has been updated to: "
                },
                f46:{
                    es:"Eliminar",
                    en:"Remove"
                },
                f49:{
                    es:"Predeterminada",
                    en:"Default"
                },
                f47:{
                    es:"Dirección eliminada",
                    en:"Address removed"
                },
                f48:{
                    es:"La direccion ha sido removida de tus preferencias",
                    en:"The address has been removed"
                },
            },
            referedColony:"",
            referedCity:"",
            colonies:[],
            searchingColonies:false,
            choosingColony:false,
            choosingCity:false,
            form:{
                name:'',
                lastName:'',
                email:'',
                number:''
            },
            accountDataPending:false,
            addressDataPending:false,
            selectedIndexAddress:0,
            addressStructure:{
                    title:"",
                    street:{
                        value:"",
                        error:"",
                    },
                    extNumber:{
                        value:"",
                        error:"",
                    },
                    intNumber:{
                        value:"",
                        error:"",
                    },
                    crossings:{
                        value:"",
                        error:"",
                    },
                    colony:{
                        value:"",
                        error:"",
                    },
                    storeNumber:"",
                    zip:"",
                    state:"",
                    stateCode:"",
                    typeColony:"",
                    city:"",
                    cityCode:"",
                    comment:{
                        value:"",
                        error:0,
                    },
                },
            /*addresses:[
                {
                    title:"",
                    street:{
                        value:"",
                        error:"",
                    },
                    extNumber:{
                        value:"",
                        error:"",
                    },
                    intNumber:{
                        value:"",
                        error:"",
                    },
                    crossings:{
                        value:"",
                        error:"",
                    },
                    colony:{
                        value:"",
                        error:"",
                    },
                    storeNumber:"",
                    zip:"",
                    state:"",
                    stateCode:"",
                    typeColony:"",
                    city:"",
                    cityCode:"",
                    comment:{
                        value:"",
                        error:0,
                    },
                }
            ]*/

            addresses:[],
            
            regNames:new RegExp(/^[a-zA-ZÀ-úñ ]{3,50}$/g),
            regText:new RegExp(/^[a-zA-ZÀ-úñ0-9 ]{3,50}$/g),
            regText2:new RegExp(/^[a-zA-ZÀ-úñ0-9 ]{1,50}$/g),
            regAlphanumeric:new RegExp(/^[a-zA-Z0-9]{1,50}$/g),
            regComment:new RegExp(/^[a-zA-ZÀ-úñ0-9()#., ]{5,150}$/g),
            regPhone:new RegExp(/^[0-9]{10,10}$/g),
            regEmail:new RegExp(/^[a-zA-Z0-9_.]{3,64}@[a-z0-9]{3,64}\.[a-z0-9]{2,10}(?:\.[a-z]{2,10}|)$/g),

            mess:'',
            successTitle:"",
            modalSuccess:0,
            errorTitle:"",
            modalError:0,
            modalUnhapp:0
        }
    }
}
</script>
<style lang="css" scoped>
    #accountContent{
        min-height: calc(100vh - 118px);
        min-width: 100vw;
    }
    .accountInner{
        padding-bottom: 150px;
        min-height: calc(100vh - 118px);
    }
    .errMess{
        color: var(--quinary);
    }
    .titled{
        color: var(--primary);
        line-height: 1.2;
        font-size: 45px;
    }

    .pointTitle{
        color: var(--text16);
        line-height: 1.2;
        font-size: 15px;
    }

    .subtitled{
        color: var(--dodecagenary);
        line-height: 1.2;
        font-size: 24px;
    }

    .inputLogin{
        min-height: 60px;
        border: 2px solid var(--ondecagenary);
        border-radius: 12px;
        font-size: 19px;
        outline: none;
    }

    .inputLogin::placeholder{
        font-size: 18px;
        letter-spacing: 0.1em;
        font-weight: 400;
        color: var(--text15);
        opacity: 0.5;
    }

    .inputAddress{
        min-height: 60px;
        border: 2px solid var(--ondecagenary);
        border-radius: 12px;
        padding-right: 70px;
        font-size: 19px;
        outline: none;
    }

    .inputAddress::placeholder{
        font-size: 18px;
        letter-spacing: 0.1em;
        font-weight: 400;
        color: var(--text15);
        opacity: 0.5;
    }

    .inputLogin:focus, .inputAddress:focus{
        border-color:var(--terdecagenary)
    }

    .accountButton{
        font-size: 18px;
        background-color: var(--tertiary);
        color:var(--text3);
        border: 2px solid var(--text12);
        outline: none;
        border-radius: 12px;
        pointer-events: none;
        transition: all 0.2s ease;
    }

    .accountButton.off{
        color:var(--text12);
    }

    .accountButton.pushable{
        pointer-events: all;
        cursor: pointer;
    }

    .accountButton.active{
        background-color: var(--primary);
        border: 2px solid var(--primary);
        color:var(--text2);
    }

    .accountButton.pushable:hover{
        background-color: var(--primary);
        border: 2px solid var(--primary);
        filter: contrast(0.9);
        color:var(--text2);
    }

    .accountButton.pushable:active{
        transform: scale(1);
        background-color: var(--quinary);
    }

    .accountButtonReset{
        font-size: 15px;
        background-color: var(--tertiary);
        color:var(--text12);
        outline: none;
        border: 2px solid var(--text12);
        border-radius: 12px;
    }

    .accountButtonReset:hover{
        background-color: var(--ondecagenary);
        color:var(--tertiary)
    }
    

    .separator{
        border-top:1px solid var(--ondecagenary);
        box-shadow: 0.5px 0.5px 0.5px rgba(200, 200, 200, 0.5);
    }

    .textareaSimulator{
        border: 2px solid var(--text12);
        border-radius: 7px;
        padding: 40px 35px;
        font-size: 18px;
        color:var(--sexadecagenary);
        cursor: pointer;
    }

    .textareaSimulator:hover{
        border:2px solid var(--primary);
        
    }

    .colonyAddress{
        font-weight: bold;
    }

    .editAccess{
        position: absolute;
        right: 20px;
        bottom: 10px;
        font-size: 19px;
        color: var(--primary);
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;
    }
    .editAccess:hover{
        filter: contrast(8)
    }
    .setDefAddress{
        position: absolute;
        right: 100px;
        bottom: 10px;
        font-size: 19px;
        color: var(--septagenary);
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
        text-align: right;
        -webkit-user-select: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;
    }
    .setDefAddress:hover{
        filter: contrast(8)
    }
    .removeAddress{
        position: absolute;
        right: 10px;
        top: 10px;
        font-size: 19px;
        color: var(--primary);
        opacity: 0.5;
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
        text-align: right;
        -webkit-user-select: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;
    }
    .removeAddress:hover{
        filter: contrast(8)
    }

    .addressCard{
        border: 1.5px solid var(--text12);
        border-radius: 14px;
        padding: 22px 24px;
        background-color: #fff;
        cursor: pointer;
        transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
        gap: 20px;
        align-items: stretch;
    }
    .addressCard:hover{
        border-color: var(--primary);
        box-shadow: 0 4px 14px rgba(0,0,0,0.06);
    }
    .addressCard--default{
        border-color: var(--primary);
        border-left-width: 6px;
        padding-left: 20px;
    }

    .addressCard__icon{
        flex: 0 0 56px;
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background-color: var(--nonagenary, #f5f5f5);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--primary);
        align-self: flex-start;
    }
    .addressCard--default .addressCard__icon{
        background-color: var(--primary);
        color: #fff;
    }
    .addressCard__icon svg{
        width: 28px;
        height: 28px;
        fill: currentColor;
    }

    .addressCard__content{
        flex: 1 1 auto;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
    .addressCard__head{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 2px;
    }
    .addressCard__title{
        font-weight: 700;
        font-size: 22px;
        color: var(--sexadecagenary);
        line-height: 1.2;
    }
    .addressCard__badge{
        display: inline-flex;
        align-items: center;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        padding: 4px 10px;
        border-radius: 999px;
        background-color: var(--primary);
        color: #fff;
        line-height: 1;
    }
    .addressCard__line{
        font-size: 16px;
        color: var(--sexadecagenary);
        line-height: 1.35;
    }
    .addressCard__line--muted{
        color: var(--septagenary);
        font-size: 15px;
    }
    .addressCard__comment{
        margin-top: 6px;
        font-size: 14px;
        color: var(--septagenary);
        font-style: italic;
        border-left: 3px solid var(--text12);
        padding-left: 10px;
    }

    .addressCard__actions{
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
    }
    .addressCard__btn{
        appearance: none;
        border: 1.5px solid var(--text12);
        background-color: #fff;
        width: 38px;
        height: 38px;
        border-radius: 10px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: var(--septagenary);
        cursor: pointer;
        padding: 0;
        transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease, transform 0.1s ease;
    }
    .addressCard__btn:hover{
        color: var(--primary);
        border-color: var(--primary);
    }
    .addressCard__btn:active{
        transform: scale(0.94);
    }
    .addressCard__btn svg{
        width: 18px;
        height: 18px;
        fill: currentColor;
    }
    .addressCard__btn--danger:hover{
        color: #fff;
        background-color: var(--primary);
        border-color: var(--primary);
    }

    @media (max-width: 575.98px){
        .addressCard{
            flex-wrap: wrap;
            padding: 18px;
            gap: 14px;
        }
        .addressCard__icon{
            flex: 0 0 44px;
            width: 44px;
            height: 44px;
        }
        .addressCard__icon svg{
            width: 22px;
            height: 22px;
        }
        .addressCard__actions{
            flex: 0 0 100%;
            flex-direction: row;
            justify-content: flex-end;
            padding-top: 8px;
            border-top: 1px solid var(--text12);
        }
        .addressCard__title{
            font-size: 19px;
        }
    }

    .filler{
        position:absolute;
        top:105%;
        left:0;
        min-height:100px;
        max-height:300px;
        overflow-y:auto;
        overflow-x:hidden;
        width:calc(100% - 1rem);
        background-color:#444;
        color:#fff;
        font-size:18px;
        border-radius:12px;
        padding-bottom:15px;
        padding-top:5px;
        z-index: 1000;

    }
    .filler::-webkit-scrollbar {
        width: 12px; /* Ancho de la barra de desplazamiento */
    }

    .filler::-webkit-scrollbar-thumb {
        background-color: var(--primary); /* Color del "pulgón" de la barra de desplazamiento */
        border-radius: 12px; /* Borde redondeado del "pulgón" */
    }

    .filler::-webkit-scrollbar-track {
        background-color: transparent; /* Color de fondo de la barra de desplazamiento */
    }

    .colony{
        cursor:pointer;
        white-space:preline
    }

    .colony:hover{
        background-color:var(--primary)
    }

    .checkIcon, .errorIcon{
        width: 30px;
        height: 30px;
    }

    .checkIcon circle{
        fill:var(--septadecagenary)
    }
    .errorIcon circle{
        fill:var(--quinary)
    }
    .checkIcon path{
        stroke:#fff
    }
    .errorIcon line{
        stroke:#fff
    }

    .serviceLabel{
        font-size: 18px;
        height: 100%;
        color: var(--dodecagenary);
    }

    .superponIcon{
        position: absolute;
        right:0;
        top:0;
        height: 100%;
        width: 50px;
        z-index: 100;
    }
</style>